import React from "react";

const SingleItem = ({
  index,
  data,
  handleDelete,
}) => {

  const marketData = data?.crypto_market_id || data?.forex_market_id || data?.metal_market_id || data?.stock_market_id;

  return (
    <>
      <tr>
        <td data-label="Crypto">
          <div className="user">
            <div className="thumb">
              <img src={`https://api.wlfmobile.com/${marketData?.image}`} alt="" />
            </div>
            <span className="name"></span>
          </div>
        </td>
        <td data-label="Name">{marketData?.name || marketData?.Name}</td>
        <td data-label="market">{data?.market}</td>
        <td data-label="Price">{marketData?.price}</td>
        <td data-label="Status">
          {marketData?.status || marketData?.Status ? (
            <span className="badge badge--success text-success">Enabled</span>
          ) : (
            <span>
              <span class="badge badge--warning text-warning">Disabled</span>
            </span>
          )}
        </td>
        <td data-label="Action">
          <button
            className="btn btn-sm btn-outline-danger "
            onClick={() => handleDelete(data?._id)}
          >
            <i className="la la-trash"></i> Remove
          </button>
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
